import PropTypes from 'prop-types';
import React, { createRef, useEffect, useRef, useState } from 'react';

import { useCursorContext } from '$contexts/cursor.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {React.FC<PropTypes.InferProps<typeof propTypes>>}
 */
const ModuleTopicsBlock = ({
    items,
    header
}) => {
    // misc
    const _items = items.filter(itm => itm.topic);

    // references
    const buttonRefs = useRef(_items.map(() => createRef()));

    // state
    const [ showAllTags, setShowAllTags ] = useState(false);

    // hooks
    const { dispatch: cursorDispatch } = useCursorContext();

    useEffect(() => {
        const hoverMediaItems = buttonRefs.current.map((btRef, idx) => {
            return cursorDispatch({
                type: 'registerArea',
                data: {
                    labelContent: () => (<img className='cursor__image' src={_items[idx].image.px2} />),
                    ref: btRef
                }
            });
        });

        return () => {
            if (hoverMediaItems.length > 0) {
                hoverMediaItems.map(cleanup => cleanup());
            }
        };
    }, [ buttonRefs.current ]);

    // render
    return (
        <>
            <div className='layout-container relative md:flex pt-40 pb-60 md:pt-100 md:pb-80'>
                <div className='md:w-1/12' />

                <div className='md:w-11/12'>
                    {header && (
                        <h2 className='type-style-1 mb-40 md:mb-60 sm:w-8/12 md:w-7/11'>
                            {header}
                        </h2>
                    )}

                    <div className='flex flex-wrap gap-10'>
                        {_items?.length <= 12 && _items.map((item, idx) => {
                            return (
                                <a
                                    className='pill-image-button'
                                    href={item.topic.url}
                                    key={idx}
                                    ref={buttonRefs.current[idx]}>
                                    <span>{item.topicLabelOverride || item.topic.title}</span>
                                    <span
                                        className='pill-image-button__image'
                                        style={{ backgroundImage: `url(${item.image.px2})` }} />
                                </a>
                            );
                        })}

                        {_items?.length > 12 && _items.slice(0, 12).map((item, idx) => {
                            return (
                                <a
                                    className='pill-image-button'
                                    href={item.topic.url}
                                    key={idx}
                                    ref={buttonRefs.current[idx]}>
                                    <span>{item.topicLabelOverride || item.topic.title}</span>
                                    <span
                                        className='pill-image-button__image'
                                        style={{ backgroundImage: `url(${item.image.px2})` }} />
                                </a>
                            );
                        })}

                        {_items?.length > 12 && (
                            <button
                                className={`${showAllTags ? 'hidden' : 'pill-image-button'}`}
                                onClick={() => { setShowAllTags(true); }}
                                type='button'>
                                &hellip;
                            </button>
                        )}

                        {showAllTags && _items?.slice(12).map((item, idx) => {
                            return (
                                <a
                                    className='pill-image-button'
                                    href={item.topic.url}
                                    key={idx}
                                    ref={buttonRefs.current[idx]}>
                                    <span>{item.topicLabelOverride || item.topic.title}</span>
                                    <span
                                        className='pill-image-button__image'
                                        style={{ backgroundImage: `url(${item.image.px2})` }} />
                                </a>
                            );
                        })}
                    </div>
                </div>
            </div>
        </>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    header: PropTypes.string,
    items: PropTypes.array.isRequired
};

ModuleTopicsBlock.propTypes = propTypes;

export default ModuleTopicsBlock;
